import styled from "styled-components"
import { useState } from "react";
import Text from "../atoms/Text"
import TabGroup from "./common/TabGroup";
import Chart from 'react-apexcharts';
import { chartColor } from "../../data/chartColor";
import { logEvent } from "../../utils/eventLogger";

const Container = styled.div`
  width: 100%;
  // padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  // justify-content: center;
  // align-items: center;
  // background-color: ${(props) => props.theme.colors.neutral[100]};
`
const ChartWrapper = styled.div`
  width: 100%;
  // min-height: 380px;
  // display:flex;
  // flex-direction: column;
  // justify-content: center;
  // algin-items: center;
  background-color: ${(props) => props.theme.colors.neutral[100]};
  border-radius: 10px;
`
const CustomLegend = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px 8px;
  justify-content: center; 
  max-width: 340px;
  margin: 0 auto;
  padding: 0 16px 20px 16px;
  @media (max-width: 320px) {
    grid-template-columns: repeat(2, 1fr);
  }
`
const LegendItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start; 
`
const Marker = styled.div`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: ${props => props.color};
  margin-right: 8px;
  flex-shrink: 0;
`
const EmptyMessage = styled.div`
  padding: 0 16px 20px 16px;
  word-break: keep-all;
  display: flex;
  justify-content: center;
  align-items: center;
`
const GuideMessage = styled.div`
  word-break: keep-all;
`

const DistributionBoard = ({ data }) => {
  const [activeTab, setActiveTab] = useState('meaning');
  const currentData = data[activeTab] || [];
  const isEmpty = currentData.length === 0;

  const tabs = [
    { id: 'meaning', label: '의미영역' },
    { id: 'wordType', label: '품사' },
    { id: 'communication', label: '의사소통 기능' },
  ];

  const handleTabChange = (id) => {
    setActiveTab(id)

    // 로그 기록
    logEvent("report_view", { reportType: `distribution-${id}` });
  };
  
  const chartSeries = isEmpty? [1] : currentData.map(item => item.value)
  
  const colors = isEmpty
    ? ['#F2F2F2']
    : currentData.map(
      (item) =>  chartColor[activeTab]?.[item.category]
    );

  const chartOptions = {
    chart: {
      type: 'donut',
      animations: { enabled: false },
      sparkline: { enabled: true },
    },
    colors: colors,
    labels: isEmpty ? ['데이터 없음'] : currentData.map(item => item.category),
    stroke: { width: 0 },
    plotOptions: {
      pie: {
        customScale: 0.8,
        expandOnClick: false,
        donut: {
          size: '65%',
          labels: { show: false },
        },
      },
    },
    tooltip: { enabled: false },
    states: {
      hover: {
        filter: { type: 'none' },
      },
      active: {
        filter: { type: 'none' },
      },
    },
    dataLabels: {
      enabled: !isEmpty,
      // formatter: (val) => `${val.toFixed(1)}%`,
      style: {
        fontSize: '14px',
        fontFamily: 'Pretendard, sans-serif',
        fontWeight: 500,
        colors: ['#ffffff'],
      },
      dropShadow: { enabled: false }
    },
    legend: {
      show: false,
      position: 'bottom',
      floating: true,
      offsetY: 0,
      fontSize: '12px',
      fontFamily: 'Pretendard, sans-serif',
      fontWeight: 400,
      itemMargin: {
        horizontal: 12,
        vertical: 6
      },
      labels: {
        colors: '#6D6F6D'
      },
      onItemClick: {
        toggleDataSeries: false
      },
      onItemHover: {
        highlightDataSeries: false
      }
    },
  }
  return (
    <Container>
      <Text variant="headline2" weight="medium">분포 차트</Text>
      <TabGroup
        tabs={tabs}
        activeTab={activeTab}
        onChange={handleTabChange}
      />
      <ChartWrapper>
        <Chart
          options={chartOptions}
          series={chartSeries}
          type="donut"
          height={300}/>
          {!isEmpty ? (
            <CustomLegend>
              {data[activeTab].map((item, index) => (
                <LegendItem key={item.category}>
                  <Marker color={chartColor[activeTab]?.[item.category]} />
                  <Text variant="caption" color="alternative">{item.category}</Text>
                </LegendItem>
              ))}
            </CustomLegend>
          ) : (
            <EmptyMessage>
              <Text variant="body2" color="alternative">대화 스크립트에서 단어를 기록하면 볼 수 있어요.</Text>
            </EmptyMessage>
          )}
      </ChartWrapper>
      <GuideMessage>
        <Text variant="caption" color="alternative">
          오늘까지 기록된 전체 누적 데이터를 기준으로 분석한 결과입니다. 더 많은 기록이 모이면 아이가 사용하는 단어의 종류를 더 정밀하게 분석할 수 있습니다.
        </Text>
      </GuideMessage>
    </Container>
  )
}

export default DistributionBoard
